import { cn } from '@heidi/utils';

import { focusRingInvalidExperimental } from '../styles/focus-ring';

import { checkboxRootBaseClasses } from './checkbox.styles';

/**
 * DS-1318 — reworked-tier Checkbox root, behind
 * `release-experimental-design-system-forms`. Only the invalid tier moves; the
 * semantic tier is tone-only, so the checked fill has nothing to migrate to yet
 * (DS-1326).
 *
 * Not `controlInvalid` — that tier excludes Checkbox (`../styles/control.ts`).
 * The technique below is borrowed from it; the tokens are not.
 */

/**
 * A bare `aria-[invalid='true']:` rule is (0,2,0) and loses to every base rule
 * that also paints the border, so each one is restated on top of the conditions
 * it has to beat.
 */
const checkboxInvalidPrecedenceExperimental = [
  // Over the checked / indeterminate border flip — (0,3,0) > (0,2,0).
  "aria-[invalid='true']:data-[state=checked]:border-semantic-border-destructive-strong",
  "aria-[invalid='true']:data-[state=indeterminate]:border-semantic-border-destructive-strong",
  // Over the hover ladder — (0,5,0) > (0,4,0). `enabled:` matches the base rules.
  "aria-[invalid='true']:enabled:data-[state=unchecked]:hover:border-semantic-border-destructive-strong",
  "aria-[invalid='true']:enabled:data-[state=checked]:hover:border-semantic-border-destructive-strong",
  "aria-[invalid='true']:enabled:data-[state=indeterminate]:hover:border-semantic-border-destructive-strong",
  // Over `focusRing` — (0,3,0) > (0,2,0). Otherwise tabbing in hides the error.
  "aria-[invalid='true']:focus-visible:border-semantic-border-destructive-strong",
  "aria-[invalid='true']:focus-visible:ring-semantic-border-destructive-strong/20",
].join(' ');

export const checkboxRootClassesExperimental = cn(
  checkboxRootBaseClasses,
  focusRingInvalidExperimental,
  checkboxInvalidPrecedenceExperimental
);
